export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5383.a41e8c4f.jpg";